import { Button } from '../../core'
import { styled } from '../../styles/styled'

const Wrapper = styled('div')(({ theme }) => {
  return {
    padding: '0px 10px',
  }
})
const LinkWrapper = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '8px',
  }
})

const OrRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  borderBottom: '1px solid #CDCDCD',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  margin: '6px 0px',
  width: '100%',
}))

const Or = styled('span')(({ theme }) => ({
  backgroundColor: '#F8F8F8',
  padding: '0px 8px',
  position: 'absolute',
}))

export const DepositCtaLink = ({ label, onClick }: { label: string; onClick(): void }) => {
  return (
    <Wrapper>
      <LinkWrapper>
        <OrRow>
          <Or>or</Or>
        </OrRow>
        <div>
          <Button color="secondary" variant="text" onClick={onClick}>
            {label}
          </Button>
        </div>
      </LinkWrapper>
    </Wrapper>
  )
}
